import {observer} from "mobx-react-lite";
import React from "react";
import {useTranslation} from "react-i18next";
import {BooleanObservable} from "../../../stores/observables/booleanObservable";
import {TextObservable} from "../../../stores/observables/textObservable";
import ButtonIcon from "../../atoms/button/buttonIcon";
import TextBox from "../../atoms/input/textBox";
import "./editLabel.sass";

export interface IEditLabelProps {
  text: TextObservable;
  isEditing: BooleanObservable;
  isDisabled?: boolean;
}

const EditLabel: React.FC<IEditLabelProps> = ({
  text,
  isEditing,
  isDisabled
}) => {
  const {t} = useTranslation("translation");

  const handleEditClicked = () => {
    // Can only click edit when not already editing, always set true
    isEditing.setBoolean(true);
  };

  return (
    <>
      {isEditing.value ? (
        <TextBox type="text" value={text} disabled={isDisabled} />
      ) : (
        <div className="edit-label">
          <span>{text.text}</span>
          <ButtonIcon
            type="inline"
            onClick={handleEditClicked}
            isDisabled={isDisabled}
          >
            {t("translation:actions.edit")}
          </ButtonIcon>
        </div>
      )}
    </>
  );
};

export default observer(EditLabel);
